/* Put sidebars below content in responsive mode */
export default function () {
  $('.herald-sidebar-left').each(function () {
    if ($(window).width() < 1250) {
      if ($(this).parent().find('div').first().hasClass('herald-sidebar-left')) {
        $(this).insertAfter($(this).parent().find('.col-mod-main'));
      }
    } else {
      if (!$(this).parent().find('div').first().hasClass('herald-sidebar-left')) {
        $(this).insertBefore($(this).parent().find('.col-mod-main'));
      }
    }
  });
}